import type { ContributorSocialMedia } from '../types/contributorProfile';

/** Keys stored in the WP “social” repeater that are copy fields, not URLs (matches se-supersonic-ui / app/site). */
export const CONTRIBUTOR_SOCIAL_META_KEYS = [
  'contributors_career',
  'contributors_subject_areas',
] as const;

export type PartitionedContributorSocial = {
  socialMedia: ContributorSocialMedia[] | undefined;
  careerDescription?: string;
  subjectAreas?: string;
};

/**
 * Splits WP contributor repeater rows into real social links vs career / subject-area text.
 */
export function partitionContributorSocialMedia(
  items: ContributorSocialMedia[] | undefined,
): PartitionedContributorSocial {
  if (!items?.length) {
    return { socialMedia: undefined };
  }

  let careerDescription: string | undefined;
  let subjectAreas: string | undefined;
  const socialMedia: ContributorSocialMedia[] = [];

  for (const item of items) {
    const trimmed = item.value?.trim();

    if (item.key === 'contributors_career') {
      if (trimmed) careerDescription = trimmed;
      continue;
    }
    if (item.key === 'contributors_subject_areas') {
      if (trimmed) subjectAreas = trimmed;
      continue;
    }
    socialMedia.push(item);
  }

  return {
    socialMedia: socialMedia.length > 0 ? socialMedia : undefined,
    careerDescription,
    subjectAreas,
  };
}
